import { Pane } from 'evergreen-ui';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createEvent, deleteEvent, getEvent, getEvents, updateEvent } from '../actions/EventActions';
import CalendarView from '../components/CalendarView';

class ViewCalendar extends Component {
    render() {
        return (
            <Pane padding={24}>
                <CalendarView
                    events={this.props.events}
                    loading={this.props.loading}
                    error={this.props.error}
                    getEvents={(opts) => this.props.dispatch(getEvents(opts))}
                    getEvent={(id) => this.props.dispatch(getEvent(id))}
                    createEvent={(values) => this.props.dispatch(createEvent(values))}
                    updateEvent={(id, values) => this.props.dispatch(updateEvent(id, values))}
                    deleteEvent={(id) => this.props.dispatch(deleteEvent(id))}
                />
            </Pane>
        );
    }
}

function mapStateToProps(state) {
    return {
        events: state.calendar.events,
        loading: state.calendar.loading,
        error: state.calendar.error,
    }
}

export default connect(mapStateToProps)(ViewCalendar);
